import { render } from "./App.vue?vue&type=template&id=b5fb05bc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b5fb05bc&lang=css"
script.render = render

export default script